export interface IQuestionEnvelope {
  questionsDTO: IAdminQuestion[];
  questionCount: number;
}

export interface IAdminQuestion {
  id: string;
  question: string;
  passingText: string;
  responseType: string;
  description: string;
  passingAnswer: boolean;
  isIdentity: boolean;
}

//interface extention for custom built items like time in a datetime
export interface IAdminQuestionFormValues extends Partial<IAdminQuestion> {
}

//empty form model
export class AdminQuestionFormValues implements IAdminQuestionFormValues {
  id: string = "";
  question: string = "";
  description: string = "";
  passingText: string= "";
  responseType: string= "";
  passingAnswer: boolean = false;
  isIdentity: boolean = false;

  constructor(question?: IAdminQuestion) {
    if (question) {
      this.id = question.id;
      this.question = question.question;
      this.passingText = question.passingText;
      this.responseType = question.responseType;
      this.description = question.description;
      this.passingAnswer = question.passingAnswer;
      this.isIdentity = question.isIdentity;
    }
    Object.assign(this);
  }
}
